import { CircularProgress, Divider, Stack, Typography } from "@mui/material";
import { Mismatch } from "../../../../types/apiTypes";

export const MismatchDataCRMWrapper = ({
  children,
  isFirstUpload,
  mismatches,
}: {
  children: JSX.Element;
  isFirstUpload?: boolean;
  mismatches: Mismatch;
}) => {
  if (!isFirstUpload) return children;

  const isUpToDate = mismatches.total === 0;

  return (
    <Stack gap="16px">
      <Stack gap="8px">
        <Stack flexDirection="row" gap="8px" alignItems="center">
          <Typography
            display="flex"
            alignItems="center"
            gap="8px"
            component="span"
            variant="subtitle1"
            color="custom.textDarkBlue"
            fontWeight={500}
          >
            Data Mismatch
          </Typography>
          {!isUpToDate && !mismatches.is_syncing && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                padding: "2px 3px",
                backgroundColor: "#1C3C6C",
                minWidth: "18px",
                height: "18px",
                borderRadius: "9px",
                color: "#FFFFFF",
                fontSize: "12px",
                lineHeight: "12px",
                boxSizing: "border-box",
              }}
            >
              {mismatches.total}
            </span>
          )}
        </Stack>

        {mismatches.is_syncing ? (
          <Stack alignItems="center" justifyContent="center">
            <CircularProgress sx={{ color: "#1C3C6C" }} />
          </Stack>
        ) : (
          <Typography component="span" variant="body1" color="#4C545B">
            {isUpToDate
              ? "All data is up to date."
              : "We’ve noticed some differences between your app and CRM. Decide how\n" +
                " you want to sync the data."}
          </Typography>
        )}
      </Stack>

      <Divider />
      <Typography
        component="span"
        variant="subtitle1"
        color="custom.textDarkBlue"
        fontWeight={500}
      >
        Upload Data
      </Typography>
      {children}
    </Stack>
  );
};
